/**
 * DEV-1216. Переводы блока «Витрина сайта» на вкладке юнитов (эпик DEV-1075,
 * ADR-0040).
 *
 * Отдельным модулем, как dev1080/dev1082/dev1084: правки витрины не конфликтуют
 * с общим ru.ts, который правят все подряд.
 *
 * Вьетнамская терминология согласована со вкладкой юнитов (dev1082): юнит —
 * «căn hộ», сводка типов на сайте — «bảng loại căn».
 */

const ruShowcase = {
  title: 'Витрина сайта',
  badge: {
    units: 'Из юнитов',
    manual: 'Вручную',
  },
  toggle: 'Считать витрину из юнитов',
  hint: {
    noUnits: 'Добавьте юниты, чтобы считать витрину автоматически',
    manual: 'Включите тумблер — витрина будет считаться из юнитов',
    units: 'Считается из видимых юнитов, обновляется при каждом изменении',
  },
  confirmEnable:
    'Витрина будет рассчитана из юнитов. Текущие строки, заведённые вручную ({count} шт.), будут замещены безвозвратно. Включить?',
  confirmDisable:
    'Автопересчёт остановится — витрина замрёт в текущем виде, править её можно будет только в админке. Выключить?',
  enabled: 'Витрина считается из юнитов',
  disabled: 'Автопересчёт выключен',
  error: 'Не удалось переключить режим витрины',
  noObjectType: 'Юнитов без типа: {count} — на витрину они не попадут',
  table: {
    type: 'Тип',
    rooms: 'Комнатность',
    area: 'Площадь от, м²',
    available: 'Доступно',
    priceFrom: 'Цена от (USD)',
  },
  priceOnRequest: 'Цена по запросу',
  empty: {
    manual: 'Витрина не заполнена',
    manualHint: 'Объекты заводятся в админке',
    units: 'Строк нет — появятся видимые юниты, появятся и строки',
  },
}

const enShowcase = {
  title: 'Website showcase',
  badge: {
    units: 'From units',
    manual: 'Manual',
  },
  toggle: 'Compute showcase from units',
  hint: {
    noUnits: 'Add units to compute the showcase automatically',
    manual: 'Turn on to compute the showcase from units',
    units: 'Computed from visible units, refreshed on every change',
  },
  confirmEnable:
    'The showcase will be computed from units. The {count} manually created rows will be replaced permanently. Turn on?',
  confirmDisable:
    'Automatic recompute stops — the showcase freezes as is and is editable only in the admin app. Turn off?',
  enabled: 'Showcase is computed from units',
  disabled: 'Auto-recompute turned off',
  error: 'Could not switch the showcase mode',
  noObjectType: 'Units without a type: {count} — they will not reach the showcase',
  table: {
    type: 'Type',
    rooms: 'Rooms',
    area: 'Area from, m²',
    available: 'Available',
    priceFrom: 'Price from (USD)',
  },
  priceOnRequest: 'Price on request',
  empty: {
    manual: 'Showcase is empty',
    manualHint: 'Rows are created in the admin app',
    units: 'No rows yet — they appear once there are visible units',
  },
}

const vnShowcase = {
  title: 'Bảng loại căn trên website',
  badge: {
    units: 'Từ căn hộ',
    manual: 'Thủ công',
  },
  toggle: 'Tính từ danh sách căn hộ',
  hint: {
    noUnits: 'Thêm căn hộ để tự động tính bảng loại căn',
    manual: 'Bật để tính bảng loại căn từ căn hộ',
    units: 'Tính từ căn hộ hiển thị, cập nhật sau mỗi thay đổi',
  },
  confirmEnable:
    'Bảng loại căn sẽ được tính từ căn hộ. {count} dòng nhập thủ công sẽ bị thay thế vĩnh viễn. Bật?',
  confirmDisable:
    'Tự động tính sẽ dừng — bảng giữ nguyên hiện trạng, chỉ sửa được trong ứng dụng quản trị. Tắt?',
  enabled: 'Đã tính từ căn hộ',
  disabled: 'Đã tắt tự động tính',
  error: 'Không thể chuyển chế độ bảng loại căn',
  noObjectType: 'Căn hộ chưa có loại: {count} — sẽ không lên bảng loại căn',
  table: {
    type: 'Loại',
    rooms: 'Số phòng',
    area: 'Diện tích từ, m²',
    available: 'Còn trống',
    priceFrom: 'Giá từ (USD)',
  },
  priceOnRequest: 'Giá theo yêu cầu',
  empty: {
    manual: 'Bảng trống',
    manualHint: 'Dòng được tạo trong ứng dụng quản trị',
    units: 'Chưa có dòng — sẽ xuất hiện khi có căn hộ hiển thị',
  },
}

export const dev1216Messages = {
  ru: { properties: { showcase: ruShowcase } },
  en: { properties: { showcase: enShowcase } },
  vn: { properties: { showcase: vnShowcase } },
}
